export default class CookieHelper {
	/**
	 * Clear all cookies.
	 */
	static cleaCookies() {
		document.cookie.split(";")
			.forEach(function(c) {
				document.cookie = c.replace(/^ +/, "")
					.replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
			});

	}
}
